import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewCoupleAction {
  public static readonly type = '[AllocationViewCoupleAction] Couple';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewCoupleSetInitialState {
  public static readonly type = '[AllocationViewCoupleAction] Set Initial State';
}
